import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ModalsContactUs {
  None = 'None',
  MessageModal = 'MessageModal',
  ThankModal = 'ThankModal',
}

export type ContactUsStateType = {
  isFetching: boolean;
  showModal: ModalsContactUs;
};

const defaultState: ContactUsStateType = {
  isFetching: false,
  showModal: ModalsContactUs.None,
};

type ContactUsReducers = {
  setFetchingContactUs: CaseReducer<ContactUsStateType, PayloadAction<boolean>>;
  showModalWithMessageContactUs: CaseReducer<ContactUsStateType>;
  showThankModalContactUs: CaseReducer<ContactUsStateType>;
  hideModalContactUs: CaseReducer<ContactUsStateType>;
};
type ContactUsSelectors = {
  isFetchingContactUsSelector: (state: ContactUsStateType) => boolean;
  showModalContactUsSelector: (state: ContactUsStateType) => ModalsContactUs;
};

const contactUs = createSlice<
  ContactUsStateType,
  ContactUsReducers,
  'contactUs',
  ContactUsSelectors
>({
  initialState: defaultState,
  name: 'contactUs',
  reducers: {
    setFetchingContactUs: (state, { payload: isFetching }) => ({
      ...state,
      isFetching,
    }),
    showModalWithMessageContactUs: (state) => ({
      ...state,
      showModal: ModalsContactUs.MessageModal,
    }),
    showThankModalContactUs: (state) => ({
      ...state,
      showModal: ModalsContactUs.ThankModal,
    }),
    hideModalContactUs: (state) => ({
      ...state,
      showModal: ModalsContactUs.None,
    }),
  },
  selectors: {
    isFetchingContactUsSelector: ({ isFetching }) => isFetching,
    showModalContactUsSelector: ({ showModal }) => showModal,
  },
});

export const {
  setFetchingContactUs,
  showModalWithMessageContactUs,
  showThankModalContactUs,
  hideModalContactUs,
} = contactUs.actions;

export const { isFetchingContactUsSelector, showModalContactUsSelector } =
  contactUs.selectors;

export default contactUs.reducer;
